let language = {
    "300335": "店铺产品正在同步中，请稍后刷新页面查看同步结果。",
    "300327": "同步该产品到您的电子商店时发生错误。当前店铺无法连接到 WooCommerce，请检查您的 WooCommerce 链接状态。",
    "2200714": "同步该产品到您的电子商店时发生错误。",
    "300317": "当前店铺中该产品所属的店铺不存在。",
    "300353": "系统繁忙，请稍后再试。",
    "300351": "当前店铺产品正在同步中，请稍后再试。",
    "302104": "Shopify 目前仅支持 [带设计的 SKU] 店铺产品。",
    "302105": "Shopify 店铺产品当前仅支持固定定价配置。",
    "300350": "当前店铺已关闭，无法执行产品同步任务。",
    /*********************** Mockup Rest Code ********************** */
    "50000002": "不支持的参数类型，仅支持使用 productInstance 或 product 来创建产品模型。",
    "50000010": "模型配置错误：组装模型参数错误。",
    "50000011": "模型配置错误：模型模板的颜色占位符计算错误。",
    "50000012": "模型配置错误：模型模板的遮罩占位符计算错误。",
    "50000013": "模型配置错误：模型模板的图像占位符计算错误。",
    "50000020": "渲染模型失败。",
};

export { language }
